export enum CommonEnums {
    // GET OTPTYPE
    ADD_DEVICE = "ADD_DEVICE",
    REMOVE_DEVICE = "REMOVE_DEVICE",
    EMAIL_VERIFICATION = "EMAIL_VERIFICATION",
    MOBILE_VERIFICATION = "MOBILE_VERIFICATION",
    FORGOT_PASSWORD = "FORGOT_PASSWORD",
    RESET_PASSWORD = "RESET_PASSWORD",
    SIGNUP = "SIGNUP",
    ADD_USER = "ADD_USER",

    // ROLE ENUMS
    SUPER_ADMIN = "ROLE_SUPER_ADMIN",
    ADMIN = "ROLE_ADMIN",
    MEMBERS = "ROLE_MEMBERS",
    CHILD = "ROLE_CHILD",

    // Frequency Type
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",

    SUNDAY = "SUNDAY",
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SCAN_WHILE_CHARGING = "SCAN_WHILE_CHARGING",
    SELECT_WEEK = "Please Select Week",
    SELECT_DATE = "Please Select Date",
    SELECT_TIME = "Please Select Time",
    ENTER_VALID_URL = "Please Enter the Valid URL",
    ENTER_VALID_CHANNEL = "Please Enter the Valid Channel Name",
    MAX_UPLOAD = "Max 1 MB and Min 100 Kb Image can be uploaded",

    //Setting tab title
    CHANGEPIN = "CHANGEPIN",
    SCAN = "SCAN",
    ANTITHEFT = "ANTITHEFT",
    PARENTALCONTROL = "PARENTALCONTROL",
    // SECURITYFEATURES = "SECURITYFEATURES",
    ONLINESAFETY = "ONLINESAFETY",
    PRIVACY = "PRIVACY",
    OPTIMIZATION = "OPTIMIZATION",

    SCHEDULE_SCAN = "SCHEDULE_SCAN",
    CHANGE_PIN = "CHANGE_PIN",
    ANTI_THEFT = "ANTI_THEFT",
    PARENTAL_CONTROL = "PARENTAL_CONTROL",
    SECURITY_FEATURE = "SECURITY_FEATURE",
    YOUTUBE_SETTING = "YOUTUBE_SETTING",
    YOUTUBE = "YOUTUBE",
    SCREENTIME = "SCREENTIME",
    ANTI_SPYWARE = "ANTISPYWARE_SETTING",
    NOT_A_PREMIUM = "QH_THIS_FEATURE_IS_NOT_AVAILABLE_GO_PREMIUM",
    // YOUTUBE_SETTING = "YOUTUBE_SETTING",
    ALL = "ALL",
    IN_PROGRESS = "IN_PROGRESS",
    SUCCESS = "SUCCESS",
    SMS_FAILED = "SMS_FAILED",
    FAILED = "FAILED",
    EXPIRED = "EXPIRED",
    PENDING = "PENDING",
    SMS_SENT = "SMS_SENT",
    NOTIFIED = "NOTIFIED",
    UPDATE_ALL_DETAILS = "UPDATE_ALL_DETAILS",
    ANTITHEFT_SETTINGS = "ANTITHEFT_SETTINGS",
    SETTINGS = "SETTINGS",
    GET_SECURITY_SETTINGS = "GET_SECURITY_SETTINGS",
    CHANGE_DEVICE_NAME = "CHANGE_DEVICE_NAME",
    SCAN_FROM_CLOUD = "SCAN_FROM_CLOUD",
    COMMANDS = "COMMANDS",
    password = "password",
    text = "text",

    USer = "User",
    DEVICE = "Device",
    ACTION = "Action",
    DESCRIPTION = "Description",
    DATETIME = "Date & TIme",
    STATUS = "Status",
    LOWSCOREICON = "./assets/images/lowIcon (1).png",
    MEDIUMSCOREICON = "./assets/images/medium_score.png",
    GOODSCOREICON = "./assets/images/good_score.png",
    EXCELLENTSCOREICON = "./assets/images/excellent_score.png",
    BROWSINGPROTECTION = "BROWSINGPROTECTION",
    SCAN_SETTING = "SCAN_SETTING",

    //deviceTypes
    SYSTEM = "DESKTOP",
    MOBILE = "MOBILE",

    MAX_UPLOAD_FILE = "Max 5 MB File can be uploaded",
}
